interface Props {
    text: string;
    value: string;
    onClick: (value: string) => void;
}

export const Example = ({ text, value, onClick }: Props) => {
    return (
        <button
            className="flex w-56 h-full justify-center rounded-xl bg-j-white px-3 py-1.5 text-sm font-bold leading-6 text-j-green border-2 border-j-green whitespace-normal shadow-[0px_8px_16px_rgba(0,0,0,0.14),0px_0px_2px_rgba(0,0,0,0.12)] hover:bg-j-white-hover"
            onClick={() => onClick(value)}
        >
            <span>{text}</span>
        </button>
    );
};
